import { getAdminOrganisationByOrganisationIdUser } from '@modv/sdk'

const state = {
  users: [],
  adminUsers: [],
  pendingUsers: [],
  pendingAdminUsers: [],
  pendingUsersEmails: [],
  pendingAdminUsersEmails: []
}
const getters = {}
const mutations = {
  GET_USERS: (state, res) => {
    res.data.adminUsers.forEach((adm) => {
      adm.isSelect = false
      adm.entityType = 'adminUser'
    })
    state.adminUsers = res.data.adminUsers
    res.data.users.forEach((user) => {
      user.isSelect = false
      user.entityType = 'user'
    })
    state.users = res.data.users
    res.data.pendingAdminUsers.forEach((user) => {
      user.isSelect = false
      user.id = user._id
      user.entityType = 'pending'
      state.pendingAdminUsersEmails.push({
        email: user.email
      })
    })
    state.pendingAdminUsers = res.data.pendingAdminUsers
    res.data.pendingUsers.forEach((user) => {
      user.isSelect = false
      user.id = user._id
      user.entityType = 'pending'
      state.pendingUsersEmails.push({
        email: user.email
      })
    })
    state.pendingUsers = res.data.pendingUsers
  },
  ADD_USER: (state, res) => {
    state.users.push(res)
    state.total++
  },
  REMOVE_USER: (state, res) => {
    state.users = state.users.filter((x) => x._id !== res.userId)
    state.adminUsers = state.adminUsers.filter((x) => x._id !== res.userId)
    state.total--
  },
  ADD_ADMIN_USER: (state, res) => {
    state.adminUsers.push(res)
    state.total++
  },
  REMOVE_ADMIN_USER: (state, res) => {
    state.adminUsers = state.adminUsers.filter((x) => x._id !== res.userId)
    state.total--
  },
  REMOVE_PENDING_USER: (state, res) => {},
  SET_USER_SELECT: (state, entity) => {
    if (state.adminUsers) {
      state.adminUsers.forEach((adminUser) => {
        if (adminUser._id === entity._id) {
          adminUser.isSelect = true
        }
      })
    }
    if (state.users) {
      state.users.forEach((user) => {
        if (user._id === entity._id) {
          user.isSelect = true
        }
      })
    }
  },
  UPDATE_USER: (state, res) => {
    let user = {}
    let userIndex = state.adminUsers.findIndex((x) => x._id === res._id)
    if (userIndex === -1) {
      userIndex = state.users.findIndex((x) => x._id === res._id)
      if (userIndex !== -1) {
        user = state.users[userIndex]
      }
    } else {
      user = state.adminUsers[userIndex]
    }
    user.firstName = res.firstName
    user.lastName = res.lastName
  },
  REMOVE_INVITED_USER: (state, res) => {
    let userIndex = state.pendingAdminUsers.findIndex((x) => x._id === res.userId)
    if (userIndex === -1) {
      userIndex = state.pendingUsers.findIndex((x) => x._id === res.userId)
      state.pendingUsers.splice(userIndex, 1)
    } else {
      state.pendingAdminUsers.splice(userIndex, 1)
    }
  }
}
const actions = {
  async getUsers({ commit }, params) {
    commit(
      'GET_USERS',
      await getAdminOrganisationByOrganisationIdUser({
        organisationId: params.organisationId
      })
    )
  },
  addUser({ commit }, params) {
    commit('ADD_USER', {
      group: params.data.data
    })
  },
  removeUser({ commit }, params) {
    commit('REMOVE_USER', {
      organisationId: params.organisationId,
      groupId: params.groupId,
      userId: params.userId
    })
  },
  removePendingUser({ commit }, params) {
    commit('REMOVE_PENDING_USER', params)
  },
  udateUser({ commit }, params) {
    commit('UPDATE_USER', params.user)
  },
  removeInvitedUser({ commit }, params) {
    commit('REMOVE_INVITED_USER', { userId: params.userId })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
